export default __webpack_public_path__ + "0f7bc4e1939b19a4a99fcd8a4c58b7c1.webp";